import { formatDate } from "@/lib/utils";

interface TransactionTimeProps {
  date: string;
}

export const TransactionTime = ({ date }: TransactionTimeProps) => {
  return (
    <span className="whitespace-nowrap">
      {formatDate(date)}
    </span>
  );
};